import React, { Fragment, useContext, useEffect, useState } from 'react';
import './StandardQuestionPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import QuestionPane from "root/Questions/QuestionPane";
import {getSectionQuestions} from "root/DataFunctions/SectionFns";
import {getDataFromResponse, getNamedCustomDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import { useParams, useSearchParams } from "react-router-dom";

import GlobalContext from "root/Contexts/GlobalContext";

const StandardQuestionPageBody = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: [], details: []});

    const [ completeCount, setCompleteCount ] = useState( 0 ) ;

    let { section_number, provider_id } = useParams();

    const [search, setSearch] = useSearchParams();

    useEffect(() => {
        getData();
    }, []);

    const countCompleted = ( recordset ) =>
    {
        return recordset.reduce((cur, rec) =>
        {
                return rec.date_updated !== null  ? ++cur : cur ;
        }, 0);
    }

    const getData = () => {

        const encProviderId = encodeURIComponent(provider_id) ;

        getSectionQuestions(encProviderId, section_number, (response) =>
        {
            const responseData = getDataFromResponse(response);

            const details = getNamedCustomDataFromResponse(response, 'details' ) ;

            const completedCount = countCompleted( responseData );

            setCompleteCount( completedCount ) ;

            setData({isLoading: false, data: responseData, details: details });
        });
    };

    const onSubmitStatusChange = (table_question_id, status ) =>
    {
        if ( status === true )
        {
            const original = data.data.find((rec) =>
            {
                if ( rec.table_question_id == table_question_id )
                {
                    return rec ;
                }
            })

            if ( original.date_updated === null )
            {
                setCompleteCount(( completeCount ) => completeCount + 1);
            }
        }
    }

    const questionList = () =>
    {
        const review_status = Number(search.get( 'status' )) ;

        if (data.isLoading)
        {
            return <SpinnerDiv/>
        }
        else
        {
            return (
                data.data.map((rec) =>
                {
                    return <QuestionPane key={rec.provider_table_response_id} record={rec} onSubmitStatusChange={onSubmitStatusChange} review_status={review_status} />
                }))
        }
    }


    const progressBar = () =>
    {
        let pcent = Math.round(( completeCount / +(data.data.length)) * 100 );

        let status = null ;

        if ( pcent === 100 )
        {
            status = "success" ;
        }
        else
        {
            status = "default" ;
        }

        return (
            <Progress percent={pcent} status={status}  theme={
                {
                    error: {
                        symbol: pcent + '%',
                        trailColor: 'pink',
                        color: 'red'
                    },
                    default: {
                        symbol: pcent + '%',
                        trailColor: '#e7ebec',
                        color: 'green'
                    },
                    active: {
                        symbol: pcent + '%',
                        trailColor: 'yellow',
                        color: 'orange'
                    },
                    success: {
                        symbol: pcent + '%',
                        trailColor: 'lime',
                        color: 'green'
                    }
                }
            }/>
        )
    }

    const sessionContext = useContext( GlobalContext ) ;

    const evaluate = sessionContext.getEvaluateInfo() ;

    return (
        <Fragment>
            <PageBodyWrapper  backButton={true}>
                <div className='standard-name'><h4>{data.details.table_section_name} for {data.details.provider_name}</h4></div>
                { data.details.subtitle_long === null && <div className='standard-subtitle'><h5>{data.details.section_subtitle}</h5></div>}
                { data.details.subtitle_long !== null && <div className='standard-subtitle'><h5>{data.details.subtitle_long}</h5></div>}

                <div style={{marginTop:'10px'}}>Section Completion Status</div>
                { progressBar() }

                <div className='evaluate'>
                    {evaluate}
                </div>

                <div className='info-header-row'>
                    <div>Question</div>
                    <div>Supporting Evidence</div>
                    <div>Self-evaluation</div>
                    <div style={{textAlign:'right'}}>Action required</div>
                </div>

                {questionList()}

            </PageBodyWrapper>
        </Fragment>
    )
}

export default StandardQuestionPageBody;
